<template>
    <div class="row menu-wrapper">
        <div class="col d-flex">
            <div class="mr-auto mt-3 ml-3">
                <div v-if="userRole">
                    <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'">
                        <router-link to="/toc">
                            <logo class="logo"></logo>
                        </router-link>
                    </div>
                    <div v-else>
                        <router-link to="/" style="cursor: pointer;">
                            <logo class="logo"></logo>
                        </router-link>
                    </div>
                </div>
                <div v-else>
                    <router-link to="/" style="cursor: pointer;">
                        <logo></logo>
                    </router-link>
                </div>

                <!--******************************************-->
                <!-- ======= HAMBURGER MENU =======-->
                <!--******************************************-->

                <Slide right noOverlay class="d-md-none hamburger-wrapper" width="280">
                    <div v-if="userRole && userAccount" style="position: relative;" class="mt--5">
                        <div class="font-sm" style="position: absolute; top:0; right:20px; font-weight: 200;">
                            <div v-if="userRole" @click="logout" style="position: relative; cursor: pointer;">logout
                            </div>
                            <div v-if="userRole === 'admin'">{{userAccount.email}}</div>
                        </div>
                    </div>
                    <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                         @click="redirect('story')"
                         class="hamburger-menu-option">Story
                    </div>
                    <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                         @click="redirect('pointsSystem')"
                         class="hamburger-menu-option">Points
                    </div>
                    <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                         @click="redirect('schedule')" class="hamburger-menu-option">Schedule
                    </div>
                    <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                         @click="redirect('eligibility')" class="hamburger-menu-option">Eligibility
                    </div>
                    <div v-if="userRole === 'admin' || userRole === 'driver'"
                         @click="redirect('driverPortal')"
                         class="hamburger-menu-option">Portal
                    </div>
                    <div v-if="userRole === 'admin'"
                         @click="redirect('adminPortal')"
                         class="hamburger-menu-option">
                        <span class="text-danger border border-danger rounded px-2 ml--1">admin</span>
                    </div>
                </Slide>

            </div>
        </div>


        <!--<div class="pointer ml-auto pl-3" @click="logout">logout</div>-->
        <div v-if="userAccount"
             class="d-none d-md-flex col text-right mr-3 mt-3 ml-auto font-italic text-uppercase font-sm">
            <div class="d-flex justify-content-end">
                <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                     class="grow align-self-center align-self-center">
                    <router-link class="menu-item" to="/story">
                        Story
                    </router-link>
                </div>
                <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                     class="grow align-self-center">
                    <router-link class="menu-item" to="/points-system">
                        Scoring
                    </router-link>
                </div>
                <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                     class="grow align-self-center">
                    <router-link class="menu-item" to="/schedule">
                        Schedule
                    </router-link>
                </div>
                <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'"
                     class="grow align-self-center">
                    <router-link class="menu-item" to="/eligibility">
                        Eligibility
                    </router-link>
                </div>
                <div v-if="userRole === 'admin' || userRole === 'driver'"
                     class="grow align-self-center">
                    <router-link class="menu-item" to="/driver-portal">
                        Portal
                    </router-link>
                </div>
                <div v-if="userRole"
                     class="grow align-self-center">

                    <div>
                        <b-dropdown id="dropdown-offset" offset="-25" variant="link" class="mt--1"
                                    toggle-class="text-decoration-none" no-caret>
                            <template slot="button-content">
                                <img style="width: 18px; height: auto;" class="ml-3 pointer"
                                     src="../assets/img/user-circle-light.svg" alt="">
                            </template>
                            <b-dropdown-group>
                                <b-dropdown-header>{{userAccount.email}}</b-dropdown-header>
                                <b-dropdown-item-button @click="logout">Logout</b-dropdown-item-button>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button @click="resetPassword">Reset Password</b-dropdown-item-button>
                            </b-dropdown-group>
                        </b-dropdown>
                    </div>

                </div>
                <!--<div v-if="userRole" class="pointer grow align-self-center align-self-center menu-item"
                     @click="logout" style="position: relative;">logout
                </div>-->
                <!--<div v-if="userAccount !== null" class="ml-3 grow align-self-center">account</div>-->
                <!--<div v-if="userAccount.email && userRole === 'admin'" class="ml-3 grow align-self-center d-none d-lg-block">
                    {{userAccount.email}}
                </div>-->
                <div v-if="userRole === 'admin'" class="pointer grow align-self-center">
                    <router-link to="/admin-portal" class="text-danger border border-danger rounded px-1">admin
                    </router-link>
                </div>
                <div v-if="userRole === 'driver'" class="ml-3 grow align-self-center"><span
                        class="text-primary border border-primary rounded px-1">driver</span></div>
                <div v-if="userRole === 'industry'" class="ml-3 grow align-self-center"><span
                        class="text-info border border-info rounded px-1">industry</span></div>
            </div>
        </div>
        <!--<div v-else><router-link to="/login">login</router-link></div>-->
    </div>
</template>
<script>
    import Logo from '@/components/RufusLogo'
    import { Slide } from 'vue-burger-menu'

    export default {
        name      : 'TheHeader',
        components: {
            Logo,
            Slide
        },
        computed  : {
            userAccount () {
                return this.$store.getters.getUserAccount
            },
            user () {
                return this.$store.getters.getUser
            },
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        methods   : {
            logout () {
                let self = this
                this.$store.dispatch('logout')
                    .then(function () {
                        // Sign-out successful.
                        self.$store.dispatch('getUserAccount')
                        self.$router.push({path: '/login'})
                        //clear state

                    })
                    .catch(function (error) {
                        // An error happened
                        // self.$router.push({path: '/'})
                    })
            },
            redirect (name) {
                console.log(name)
                this.$router.push({name: name})
            },
            resetPassword () {
                let actionCodeSettings = {
                    url: 'https://www.ruf.us/login'
                }
                let emailAddress = this.userAccount.email;

                auth.sendPasswordResetEmail(emailAddress, actionCodeSettings).then(function() {
                    // Email sent.
                }).catch(function(error) {
                    if (error) {
                        console.log(error);
                    }
                    // An error happened.
                });

            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>
<style lang="scss">
    @import '../assets/css/_vars.scss';

    .btn-link {
        color: transparent !important;
        text-decoration: none;
    }

    .hamburger-menu-option {
        color: $lime;
        font-weight: 700;
        font-style: italic;
        cursor: pointer;
        padding-left: 2rem;
    }

    @media all and (max-width: 576px) {
        .menu-wrapper {
            margin-top: -10px !important;
        }
    }

    @media all and (min-width: 577px) and (max-width: 767px) {
        .menu-item {
            font-size: 12px;
            margin-left: 0.6rem;
        }
    }

    @media all and (min-width: 768px) and (max-width: 991px) {
        .menu-item {
            font-size: 13px;
            margin-left: 0.7rem;
        }
    }

    @media all and (min-width: 992px) and (max-width: 1199px) {
        .menu-item {
            font-size: 16px;
            margin-left: 1.4rem;
        }
    }

    @media all and (min-width: 1200px) {
        .menu-item {
            font-size: 16px;
            margin-left: 2rem;
        }
    }
</style>
